<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrint">
          <posSalesDetailsListTable :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList"
            :sumsTotal="sumsTotal"></posSalesDetailsListTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrintExport">
          <posSalesDetailsListTable :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList"
            :exportShow='true' :sumsTotal="sumsTotal"></posSalesDetailsListTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
  import DateUtils from '@/utils/DateUtils';
  import getLodop from '../../utils/Lodopfuncs'

  import posSalesDetailsListTable from './posSalesDetailsListTable'
  // import {
  //   posSalesDetailsList
  // } from '@/api/reportcenter/ReportTableDefinition'
  // import getLodop from '@/utils/LodopFuncs.js'
  export default {
    components: {
      posSalesDetailsListTable
    },
    data() {
      return {
        listQuery: {
          shiftCode: '',
          userId: '',
          outletId: '',
          startTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
          queryLike: ''
        },
        employee: localStorage.getItem('user'),
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: localStorage.getItem('hotelInfo'),
        loading: false,
        listShift: [{
            code: 'order_num',
            chinese_desc: '单号'
          },
          {
            code: 'people_count',
            chinese_desc: '人数'
          },
          {
            code: 'avgPeoplePrice',
            chinese_desc: '人均'
          },
        ],
        listPush: [{
            code: 'tax',
            chinese_desc: '税'
          },
          {
            code: 'discount',
            chinese_desc: '折扣'
          },
          {
            code: 'server_price',
            chinese_desc: '服务费'
          },
          {
            code: 'unPayPrice',
            chinese_desc: '挂单/未结'
          },
          {
            code: 'all_price',
            chinese_desc: '合计'
          },
          {
            code: 'payPrice',
            chinese_desc: '付款'
          },
          {
            code: 'check_type',
            chinese_desc: '支付方式'
          },
          {
            code: 'link_num',
            chinese_desc: '联单号'
          },
        ],
        tabelTitel: [{
          code: 'outletName',
          chinese_desc: '厅名'
        }, {
          code: 'typeName',
          chinese_desc: '类别'
        }, {
          code: 'dishesCode',
          chinese_desc: '编号'
        }, {
          code: 'food_name',
          chinese_desc: '名称'
        }, {
          code: 'quantity',
          chinese_desc: '数量'
        }, {
          code: 'unit_name',
          chinese_desc: '单位'
        }, {
          code: 'price',
          chinese_desc: '单价'
        }, {
          code: 'all_price',
          chinese_desc: '应收'
        }, {
          code: 'all_prices',
          chinese_desc: '实收'
        }, {
          code: 'order_num',
          chinese_desc: '单号'
        }, {
          code: 'meal_table_num',
          chinese_desc: '桌号'
        }, {
          code: 'username',
          chinese_desc: '点菜员'
        }, {
          code: 'create_date',
          chinese_desc: '点菜时间'
        }, ],
        tabelList: []
      }
    },
    created() {
      this.getInit()
      this.$bus.$on('todoQuery', this.getData)
      this.$bus.$on('todoPrintCatering', this.todoPrint)
      this.$bus.$on('todoExportCatering', this.todoExport)
    },
    beforeDestroy() {
      this.$bus.$off('todoQuery', this.getData);
      this.$bus.$off('todoPrintCatering', this.todoPrint)
      this.$bus.$off('todoExportCatering', this.todoExport)
    },
    computed: {
      sumsTotal: function () {
        let sums = []
        let arr = []

        sums[this.tabelTitel.length - 1] = undefined
        console.log(this.tabelList, this.tabelTitel);
        this.tabelTitel.map((item, index) => {
          this.tabelList.map(sItem => {

            if (typeof (sItem[item.code]) == 'number' && sItem['typeName'].includes('小计')) {
              if (!sums[index]) {
                sums[index] = 0
              }

              sums[index] += sItem[item.code] ? sItem[item.code] : 0
            }
            // }

          })
        })

        if (this.tabelTitel.length) {
          sums[0] = '合计'
        }

        return sums
      }
    },
    methods: {
      getData(val) {
        this.listQuery = Object.assign({}, val)
        this.getInit()
      },
      getInit() {


        var methods = "get"
        let url = this.api.posSalesDetailsList
        let data = {
          startTime: this.listQuery.startTime,
          endTime: this.listQuery.endTime,
          outletId: this.listQuery.outletId.toString(),
          shiftCode: this.listQuery.shiftCode,
          userId: this.listQuery.userId.toString(),
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status == 0) {
            this.tabelList = []
            let map = new Map();
            let left = 0,
              lefta = 0,
              arr = res.data.data,
              length = res.data.data.length,
              obj = {
                outletName: "",
                all_price: 0,
                quantity: 0,
                typeName: '',
                subtotal: '2'

              }
            if (res.data.data.length) {


              for (let right = 0; right < arr.length; right++) {




                if (arr[right].typeCode) {

                  arr[right].all_prices = arr[right].all_price
                  if (arr[left].typeCode != arr[right].typeCode) {
                    obj = {
                      outletName: "",
                      all_price: 0,
                      quantity: 0,
                      typeName: '',
                      total: '1',
                      subtotal: '12'

                    }
                    obj.typeName = arr[left].typeName + '小计'

                    let num = right - left

                    for (let n = 0; n < num; n++) {

                      obj.all_price += arr[left + n].all_price
                      obj.all_prices = obj.all_price
                      obj.quantity += arr[left + n].quantity

                    }

                    let objs = JSON.parse(JSON.stringify(obj))
                    this.tabelList.push(objs)
                    // arr.splice(right, 0, objs)

                    left = right
                    console.log(right, left, objs);


                  }

                  if (arr[lefta].outleteCode != arr[right].outleteCode) {
                    // debugger
                    obj = {
                      outletName: "",
                      all_price: 0,
                      quantity: 0,
                      typeName: '',
                      subtotal: '12'


                    }
                    // obj.typeName = arr[lefta].typeName 
                    obj.outletName = arr[lefta].outletName + '小计'


                    let num = right - lefta
                    console.log(right, lefta);
                    for (let n = 0; n < num; n++) {

                      obj.all_price += arr[lefta + n].all_price
                      obj.all_prices = obj.all_price
                      obj.quantity += arr[lefta + n].quantity

                    }

                    let objs = JSON.parse(JSON.stringify(obj))
                    this.tabelList.push(objs)



                    lefta = right

                  }

                  this.tabelList.push(arr[right])
                  if (right == arr.length - 1) {
                    console.log(right, left, arr.length, arr[right]);

                    if (left == right) {
                      obj = {
                        outletName: "",
                        all_price: 0,
                        quantity: 0,
                        typeName: '',
                        total: '1',
                        subtotal: '12'
                      }
                      obj.typeName = arr[left].typeName + '小计'
                      obj.all_price = arr[left].all_price
                      obj.all_prices = obj.all_price
                      obj.quantity = arr[left].quantity
                      let objs = JSON.parse(JSON.stringify(obj))

                      this.tabelList.push(objs)


                    } else {
                      obj = {
                        outletName: "",
                        all_price: 0,
                        quantity: 0,
                        typeName: '',
                        total: '1',
                        subtotal: '12'
                      }
                      obj.typeName = arr[left].typeName + '小计'
                      let num = right - left + 1
                      for (let n = 0; n < num; n++) {
                        obj.all_price += arr[left + n].all_price
                        obj.all_prices = obj.all_price
                        obj.quantity += arr[left + n].quantity
                      }

                      let objs = JSON.parse(JSON.stringify(obj))
                      this.tabelList.push(objs)
                    }

                    if (lefta == right) {
                      obj = {
                        outletName: "",
                        all_price: 0,
                        quantity: 0,
                        typeName: '',
                        total: '1',
                        subtotal: '12'
                      }
                      obj.typeName = ''
                      obj.outletName = arr[left].outletName + '小计'
                      obj.all_price = arr[left].all_price
                      obj.all_prices = obj.all_price
                      obj.quantity = arr[left].quantity
                      let objs = JSON.parse(JSON.stringify(obj))

                      this.tabelList.push(objs)


                    } else {
                      obj = {
                        outletName: "",
                        all_price: 0,
                        quantity: 0,
                        typeName: '',
                        total: '1',
                        subtotal: '12'
                      }
                      obj.typeName = ''

                      obj.outletName = arr[left].outletName + '小计'
                      let num = right - left + 1
                      console.log(num);
                      for (let n = 0; n < num; n++) {
                        obj.all_price += arr[left + n].all_price
                        obj.all_prices = obj.all_price
                        obj.quantity += arr[left + n].quantity
                        console.log(num, obj.quantity, left, n, arr[left + n].quantity);
                      }

                      let objs = JSON.parse(JSON.stringify(obj))
                      this.tabelList.push(objs)
                    }



                  }

                }



              }
              // console.log(arr);

              // this.tabelList = arr

            }


          }
        })
      },
      todoPrint(type) {
        const LODOP = getLodop()
        // 获取大小和宽度
        let printSize = 12
        let width = 2
        if (LODOP) {
          // 判断是否是数字
          let falg = false
          if (document.getElementById('tablePrint')) {
            document.getElementById("copy_div").innerHTML = ""
            let innerHTML = document.getElementById('tablePrint').cloneNode(true)
            innerHTML.style.border = 'none'
            innerHTML.style.borderCollapse = 'collapse'
            innerHTML.style.fontSize = printSize + 'px'
            document.getElementById("copy_div").appendChild(innerHTML);
            falg = true
          }
          this.$nextTick(() => {
            var strFormHtml = `
                <body >` +
              document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
              '</body>' //获取打印内容
            LODOP.PRINT_INIT('') //初始化
            LODOP.SET_PRINT_PAGESIZE(0, 0, 0, 'A4') //设置打印方向
            LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
            LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '') //设置预览窗口模式和大小
            LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, "第#页/共&页");
            LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
            LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
            LODOP.SET_PRINT_STYLEA(0, "Vorient", 1);
            if (type === 'preview') {
              LODOP.PREVIEW();
            } else {
              LODOP.PRINT()
            }
          })

        }
      },
      todoExport() {
        const LODOP = getLodop()
        if (LODOP) {
          // 获取大小和宽度
          let width = 2
          var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>' //获取打印内容
          LODOP.PRINT_INIT('') //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') //设置纵向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
          LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
          LODOP.SAVE_TO_FILE("餐饮部销售明细表.xlsx");
        }
      }
    }
  }
</script>